import {
  customStylesSelect,
  hoursReportStatus,
  SupervisorReportStatus,
} from "common/data/settings"
import CustomSelectwithLabel from "components/Common/CustomSelectwithLabel"
import React, { Fragment, useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import Select from "react-select"
import { Col, Collapse, Row, Form } from "reactstrap"
import AsyncSelect from "react-select/async"
import { getAuthorizationToken } from "helpers/storagehelper"
import { useSelector,useDispatch } from "react-redux"
import { getAllAgentDetails } from "store/manageclient/action"

const Filter = props => {
  const { handleSubmit, setExpandedRow, setSelectname, selectname ,selectAgent } = props

  const [allUsers, setAllUser] = useState([])
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
  const dispatch = useDispatch();

  // Get access permissions
  const accessSetting = authUser?.data?.useraccessgroupsettings || {}
  const hasAccessAllTeam = accessSetting?.accessAllTeam

  // Filter hoursReportStatus based on accessAllTeam permission
  const filteredHoursReportStatus = hoursReportStatus.filter(option => {
    // Show "Unapproved Evaluation hours" (id: 6) only if user has accessAllTeam permission
    if (option.id === 6) {
      return hasAccessAllTeam === true
    }
    return true
  })

  useEffect(() => {
    dispatch(getAllAgentDetails())
    getUserListData(authUser.data?.firstname.substr(0, 2), () => {}, undefined)
  }, [])

  const { Agents_list } = useSelector(state => ({
    Agents_list: state?.manageclient?.getallagentslist,
  }))

  const getUserListData = async (
    searchValue,
    callback,
    searchKey = "useremail"
  ) => {
    try {
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}/Users/GetUsers`,
        {
          method: "post",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchKey,
            searchValue,
            pageNumber: 0,
            pageSize: 20,
          }),
        }
      )
        .then(res => res.json())
        .then(res => {
          setAllUser(res.data)
          return res.data.map(el => ({
            ...el,
            label: el.username,
            value: el.id,
          }))
        })
      callback(data)
      return data
    } catch (err) {
      console.log(err, "err")
      return []
    }
  }

  const [selectedClient, setSelectedClient] = useState([
    {
      label: "All",
      value: "11",
    },
  ])
  const [selectedProject, setSelectedProject] = useState([
    {
      label: "All",
      value: "11",
    },
  ])

  const [isadvancefilter, setisadvancefilter] = useState(false)
  const [filtersub, setfiltersub] = useState(null)
  const [ids, setids] = useState(null)

  // Sorting the Dropdown values
  function SortArray(x, y) {
    if (x.name < y.name) {
      return -1
    }
    if (x.name > y.name) {
      return 1
    }
    return 0
  }

  const maincategory = props.MainCategory?.sort(SortArray)

  const startDateChange = date => {
    setExpandedRow(null)
    props.setStartDate(date)
  }
  const endDateChange = date => {
    setExpandedRow(null)
    props.setEndDate(date)
  }
  const toggleAdvanceFilter = e => {
    e.preventDefault()
    setisadvancefilter(!isadvancefilter)
  }

  useEffect(() => {
    const filteredData = ids?.id
      ? props.teams?.filter(el => el?.categoryId === ids?.id)
      : props.teams
    setfiltersub(filteredData)
  }, [ids])

  var mergeMainCategory = maincategory?.map(item => ({
    clientName: item.name,
    id: item.id,
  }))

  var mergeSubCategory = filtersub?.map(item => ({
    projectName: item?.name,
    id: item?.id,
    categoryId: item?.categoryId,
  }))

  const projectFilter = value => {
    props.setSelectedprojectId(value)
    setSelectedProject(value)
  }

  const clientFilter = value => {
    props.setSelectedclientId(value)
    setSelectedClient(value)
    setids(value)
  }
  const handleNameFilter = value => {
    setSelectname(value)
    props.handleNameDropdownFilter(value)
  }

  const agentFilter = value =>{
     props.setSelectAgent(value)
  }
  const loadOptions = (inputValue, callback) => {
    getUserListData(inputValue, callback)
  }
  useEffect(() => {
    if (selectname?.label === "All" || selectname == null) {
      getUserListData(
        authUser.data?.firstname.substr(0, 2),
        () => {},
        undefined
      )
    }
  }, [selectname])
  return (
    <Fragment>
      <Row>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-2 mobile_responsive_user">
            <Col lg={2} className=" justify-content-start">
              <DatePicker
                dateFormat="yyyy-MM-dd"
                selected={props.startDate}
                onChange={startDateChange}
                className="form-control mb-2 date-icon-back"
                placeholderText="Select date"
                maxDate={new Date()}
              />
            </Col>
            <Col lg={2} className=" justify-content-start">
              <DatePicker
                dateFormat="yyyy-MM-dd"
                selected={props.endDate}
                onChange={endDateChange}
                className="form-control mb-2 date-icon-back"
                placeholderText="Select date"
                minDate={new Date(props.startDate)}
              />
            </Col>
            <Col lg={2} className=" justify-content-start">
              <Select
                className="mb-2"
                value={props.activeReportStatus}
                onChange={value => props.handleReportFilter(value)}
                options={filteredHoursReportStatus}
                classNamePrefix="select2-selection"
                placeholder="Select Report"
                styles={customStylesSelect}
              />
            </Col>

            <Col lg="2">
              {props.activeReportStatus?.id == 3 && (
                <Select
                  className="mb-2"
                  value={props.supervisorFilter}
                  onChange={value => props.handleSupervisorReportFilter(value)}
                  options={SupervisorReportStatus}
                  classNamePrefix="select2-selection"
                  placeholder="Select Report"
                  styles={customStylesSelect}
                />
              )}
            </Col>
            <Col lg={4}>
              <div className="d-flex mobile_responsive_user">
                <button
                  className="btn btn-primary mb-2 me-2"
                  type="submit"
                  onClick={handleSubmit}
                  style={{ width: "100%" }}
                >
                  <i className="bx bx-filter-alt align-middle"></i> Filter
                </button>
                <button
                  onClick={e => toggleAdvanceFilter(e)}
                  className="btn btn-primary  mb-2 me-2"
                  style={{ width: "100%" }}
                >
                  <i className="bx bx-filter-alt align-middle"></i> Advance
                </button>
                <button
                  onClick={e => props.GetHourSummaryReport(e)}
                  className="btn btn-primary mb-2"
                  style={{ width: "100%" }}
                >
                  <i className="bx bx-download align-middle"></i> Export
                </button>
              </div>
            </Col>
          </Row>
        </Form>

        <Col sm="12" className="mt-2 mb-2">
          <Collapse isOpen={isadvancefilter} className="mt-2">
            <Row>
              <Col md="3">
                <label>Name</label>
                <AsyncSelect
                  styles={customStylesSelect}
                  value={selectname}
                  isClearable
                  onChange={value => handleNameFilter(value)}
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions={[{ label: "All" }].concat(
                    allUsers?.map(el => ({
                      ...el,
                      label: el.username,
                      value: el.id,
                    }))
                  )}
                  classNamePrefix="select2-selection"
                  className="add_Zindex_one pb-1"
                />
              </Col>

              <CustomSelectwithLabel
                label={props.companySetting?.MainCategory}
                isClearable
                value={selectedClient}
                placeholder="All"
                onChange={value => clientFilter(value)}
                options={[{ label: "All" }].concat(
                  mergeMainCategory?.map(el => ({
                    ...el,
                    label: el?.clientName,
                    value: el?.clientName,
                  }))
                )}
              />
              <CustomSelectwithLabel
                label={props.companySetting?.SubCategory}
                isClearable
                value={selectedProject}
                placeholder="All"
                onChange={value => projectFilter(value)}
                options={[{ label: "All" }].concat(
                  (mergeSubCategory || [])?.map(el => ({
                    ...el,
                    label: el?.projectName,
                    value: el?.projectName,
                  }))
                )}
              />

              <CustomSelectwithLabel
                label={"Agent"}
                isClearable
                value={selectAgent}
                placeholder="All"
                onChange={value => agentFilter(value)}
                options={[{ label: "All" }].concat(
                  (Agents_list || [])?.map(el => ({
                    ...el,
                    label: el?.name,
                    value: el?.name,
                  }))
                )}
              />
            </Row>
          </Collapse>
        </Col>
      </Row>
    </Fragment>
  )
}

export default Filter
